import {ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core';
import {CoverImageComponent, DEFAULT_IMAGE_ALT, MinimalCatalogRecord, XAlignment, YAlignment} from '@aviary/components/cover-image/cover-image.component';

@Component({
  selector: 'mx-combined-cover-image-and-content',
  template: `
    <div class="flex flex-row items-stretch gap-x-[var(--gapWidth)]">
      <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="coverWidthRem" [heightRem]="coverHeightRem" [minHeightRem]="coverMinHeightRem"
                      [maxHeightRem]="coverMaxHeightRem" [xPaddingRem]="coverXPaddingRem" [yPaddingRem]="coverYPaddingRem" [xAlignment]="coverXAlignment"
                      [yAlignment]="coverYAlignment" [alt]="coverAlt" [priority]="coverPriority"/>

      <div class="flex-1 min-w-0">
        <ng-content/>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoverImageComponent]
})
export class CombinedCoverImageAndContentComponent {

  @Input({required: true}) public catalogRecord: MinimalCatalogRecord | undefined;
  @Input({required: true}) public coverWidthRem: number;
  @Input() public coverHeightRem?: number;
  @Input() public coverMinHeightRem?: number;
  @Input() public coverMaxHeightRem?: number;
  @Input() public coverXPaddingRem: number = 0;
  @Input() public coverYPaddingRem: number = 0;
  @Input() public coverXAlignment: XAlignment = 'CENTER';
  @Input() public coverYAlignment: YAlignment = 'TOP';
  @Input() public coverAlt: string = DEFAULT_IMAGE_ALT;
  @Input() public coverPriority: boolean = false;

  @Input() gapWidthRem: number = 1; // Gap between cover and content.

  // noinspection CssUnknownProperty
  @HostBinding('style.--gapWidth') get gapWidth() {
    return `${this.gapWidthRem}rem`;
  }
}
